
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/recurring-reminders-microsoft-teams-tutorial",
      function () {
        return require("private-next-pages/article/recurring-reminders-microsoft-teams-tutorial.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/recurring-reminders-microsoft-teams-tutorial"])
      });
    }
  